import { createReducer, createSetter } from "@/redux/helpers/reducer";

import * as actions from "./company-session.actions";
const initialState = {
  currentCompany: null,
};

export default createReducer(initialState, {
  [actions.setCurrentCompany]: createSetter("currentCompany"),
  [actions.reset]: () => ({ ...initialState }),
});
